const dateOptions = {
  year: 'numeric', month: '2-digit', day: '2-digit'
}

export default {

  renderTrafficLight(color, fieldName, slotData) {
    let res = '';
    switch (color) {
      case "AVAILABLE":
        res = '<span class="mf-box-green">available</span>';
        break;
      case "NOT_AVAILABLE":
        res = '<span class="mf-box-red">not avail</span>';
        break;
      case "TBA":
        res = '<span class="mf-box-yellow">tba</span>';
        break
      default:
        console.log('Fallback: ' + color);
        res = color;
    }

    let icon = "";
    let fieldParts = fieldName.split('_');
    if (fieldParts.length > 1) {
      let no = fieldParts[1];
      if (Object.prototype.hasOwnProperty.call(slotData, 'trafficLights_' + no + '_hasSCContract')) {
        if (slotData['trafficLights_' + no + '_hasSCContract'] === true) {
          icon = icon + '<i title="first usage" class="pi pi-check"></i>';
        }
      }
    }

    res = '<span class="traffic-light-value">' + res + '</span>';

    if (icon) {
      res = res + '<span class="traffic-light-icon">' + icon + '</span>';
    }

    res = '<span class="traffic-light-display">' + res + '</span>';

    return res;
  },

  renderTimeSpans(value, fieldName, slotData) {
    let fieldParts = fieldName.split('_');
    // fieldName should look like trafficLights_0_timeSpans_0_exclusive
    console.log("FieldParts", {fieldParts: fieldParts});
    let tlNo = fieldParts[1];
    let resList = [];
    let timeSpanNo = 0;
    while (Object.prototype.hasOwnProperty.call(slotData, 'trafficLights_' + tlNo + '_timeSpans_' + timeSpanNo + '_from')) {
      let timeSpanText =
        '<span class="timespan-value">'
        + new Date(slotData['trafficLights_' + tlNo + '_timeSpans_' + timeSpanNo + '_from']).toLocaleDateString(undefined, dateOptions)
        + ' - '
        + new Date(slotData['trafficLights_' + tlNo + '_timeSpans_' + timeSpanNo + '_to']).toLocaleDateString(undefined, dateOptions)
        + '</span>';

      let icon;

      if (slotData['trafficLights_' + tlNo + '_timeSpans_' + timeSpanNo + '_exclusive']) {
        icon = "<i title=\"exclusive\" class=\"pi pi-star\"></i>";
      } else if (slotData['trafficLights_' + tlNo + '_timeSpans_' + timeSpanNo + '_partialExclusive']) {
        icon = "<span title='partial exclusive'> (PE)</span>"
      } else {
        icon = "<i title=\"exclusive\" class=\"pi pi-star-o\"></i>"
      }

      if (icon) {
        timeSpanText = timeSpanText + '<span class="timespan-icon">' + icon + '</span>';
      }

      timeSpanText = '<span class="timespan-display">' + timeSpanText + '</span>';

      resList.push(timeSpanText);

      timeSpanNo++;
    }
    console.log("ResList", {resList: resList});
    return resList.join("; ");

  },
  renderDefault(value) {
    return value;
  },
  renderCurrency(value) {
    let number = Number.parseFloat(value);
    if (isNaN(number)) {
      return value;
    } else {
      return number.toLocaleString(
        undefined,
        {minimumFractionDigits: 2})
    }
  },
  renderBoolean(value) {
    if (value === 'true' || value === true) {
      return '<i title="yes" class="pi pi-circle-on"></i>';
    }
    return '<i title="no" class="pi pi-circle-off"></i>';
  }
}
